<template>
  <div class="rfp-review-status pos-relative fullheight">
    <Spin size="small" fix v-if="isLoading"></Spin>
    <Card style="width:400px;text-align:center" class="centered" v-else>
      <div :style="{background: color_info}" style="text-align:center;padding:30px 20px">
        <Icon v-if="invalid" type="ios-alert-outline" size="100" color="#ffffff"/>
        <Icon v-else :type="(is_approved)? 'md-thumbs-up':'md-thumbs-down'" size="100" color="#ffffff"/>
      </div>
      <div style="text-align:center;padding:30px 20px">
        <div v-if="invalid">
          <h2> {{ invalid }} </h2>
        </div>
        <div v-else>
          <p>RFP</p>
          <h2 v-if="is_approved">APPROVED</h2>
          <h2 v-else>DECLINED</h2>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { approveRfp, declineRfp } from '@/services/rfps.js'

export default {
  data () {
    return {
      isLoading: false,
      is_approved: null,
      invalid: null,
      color_info: null
    }
  },

  mounted () {
    if (this.$route.query && this.$route.query.status && this.$route.query.status === '1') {
      this.handleApprovedRfp()
    } else {
      this.handleDeclinedRfp()
    }
  },

  methods: {
    handleApprovedRfp () {
      this.isLoading = true
      approveRfp(this.$route.params.rfpNumber).then(res => {
        this.is_approved = 1
        this.color_info = '#19be6b'
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to approved rfp: ', err)
        this.color_info = '#c5c8ce'
        if (err.response.data && err.response.data.message) {
          this.$Message.error(err.response.data.message)
          this.invalid = err.response.data.message
        }
        this.isLoading = false
      })
    },

    handleDeclinedRfp () {
      this.isLoading = true
      declineRfp(this.$route.params.rfpNumber).then(res => {
        this.is_approved = 0
        this.color_info = '#ed4014'
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to declined rfp: ', err)
        this.color_info = '#c5c8ce'
        if (err.response.data && err.response.data.message) {
          this.$Message.error(err.response.data.message)
          this.invalid = err.response.data.message
        }
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
.rfp-review-status {
  .ivu-card {
    overflow: hidden;
    .ivu-card-body {
      padding: 0px;
    }
  }
}
</style>
